import { axios } from './commons';

export default {
  getMetaList: (endpoint, pageNo = 1) =>
    axios.get(`${endpoint}?page=${pageNo}`),
};
